"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.handleClickItem = void 0;
const useMenuClickHandlers_1 = require("../../../../components/MenuDrawer/useMenuClickHandlers");
const services_1 = require("../../../../services");
const constants_1 = require("../../../constants");
const utils_1 = require("../../../utils");
const CustomerAreaMenuItem_types_1 = require("./CustomerAreaMenuItem.types");
const handleClickItem = (type, isLogged, catalogSlug) => {
    const baseAction = 'menu:acessar-area-do-consumidor';
    const tagContext = {
        [CustomerAreaMenuItem_types_1.MenuItemCustomerAreaAccessType.orders]: ':pedidos',
        [CustomerAreaMenuItem_types_1.MenuItemCustomerAreaAccessType.profile]: ':perfil',
        [CustomerAreaMenuItem_types_1.MenuItemCustomerAreaAccessType.favorites]: ':favoritos',
    };
    services_1.GoogleAnalyticsService.event({
        event: 'ga-event',
        'event-category': 'tab-bar',
        'event-action': 'click',
        'event-label': `${baseAction}${tagContext[type] || ''}`,
    });
    if (!isLogged) {
        (0, useMenuClickHandlers_1.goTo)((0, utils_1.buildAuthSignUpUrl)(catalogSlug), false);
        return;
    }
    switch (type) {
        case CustomerAreaMenuItem_types_1.MenuItemCustomerAreaAccessType.orders:
            (0, useMenuClickHandlers_1.goTo)(`/${catalogSlug}${constants_1.CUSTOMER_AREA_ORDERS_PATH}`);
            break;
        case CustomerAreaMenuItem_types_1.MenuItemCustomerAreaAccessType.profile:
            (0, useMenuClickHandlers_1.goTo)(`/${catalogSlug}${constants_1.CUSTOMER_AREA_PROFILE_PATH}`);
            break;
        case CustomerAreaMenuItem_types_1.MenuItemCustomerAreaAccessType.favorites:
            (0, useMenuClickHandlers_1.goTo)(`/${catalogSlug}${constants_1.CUSTOMER_AREA_FAVORITES_PATH}`);
            break;
        default:
            break;
    }
};
exports.handleClickItem = handleClickItem;
